module.exports = __webpack_public_path__ + "static/media/discount.686454d2.svg";